"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weekDayToJsDay = exports.jsDayToWeekDay = exports.isInDayRange = exports.getPreviousWeekDay = exports.getNextWeekDay = exports.getLocalizedWeekdayName = exports.getLocalizedTime = exports.createDateWithTime = exports.week = void 0;
const week = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
];
exports.week = week;
const jsDayToWeekDay = (jsDay) => week[jsDay];
exports.jsDayToWeekDay = jsDayToWeekDay;
const weekDayToJsDay = (weekDay) => week.indexOf(weekDay);
exports.weekDayToJsDay = weekDayToJsDay;
const getNextWeekDay = (currentDay) => week[week.indexOf(currentDay) + 1] || week[0];
exports.getNextWeekDay = getNextWeekDay;
const getPreviousWeekDay = (currentDay) => week[week.indexOf(currentDay) - 1] || week[6];
exports.getPreviousWeekDay = getPreviousWeekDay;
const isInDayRange = (startDay, endDay, currentDay) => {
    if (currentDay === startDay || currentDay === endDay) {
        return true;
    }
    const startIndex = week.indexOf(startDay);
    const endIndex = week.indexOf(endDay);
    const currentIndex = week.indexOf(currentDay);
    if (startIndex <= endIndex) {
        return currentIndex >= startIndex && currentIndex <= endIndex;
    }
    return currentIndex >= startIndex || currentIndex <= endIndex;
};
exports.isInDayRange = isInDayRange;
const createDateWithTime = (baseDate, time) => {
    const dayStr = baseDate.getDate() < 10 ? `0${baseDate.getDate()}` : baseDate.getDate();
    const month = baseDate.getMonth() + 1;
    const monthStr = month < 10 ? `0${month}` : month;
    return time
        ? new Date(`${baseDate.getFullYear()}-${monthStr}-${dayStr}T${time}`)
        : baseDate;
};
exports.createDateWithTime = createDateWithTime;
const getLocalizedWeekdayName = (weekDay, locale) => {
    const date = new Date(2020, 2, weekDayToJsDay(weekDay) + 1);
    return new Intl.DateTimeFormat(locale, { weekday: "long" }).format(date);
};
exports.getLocalizedWeekdayName = getLocalizedWeekdayName;
const getLocalizedTime = (timeString, locale) => {
    const date = createDateWithTime(new Date(), timeString);
    return new Intl.DateTimeFormat(locale, {
        hour: "numeric",
        minute: "numeric",
    }).format(date);
};
exports.getLocalizedTime = getLocalizedTime;
//# sourceMappingURL=date-utils.js.map